import { setAuthenticator } from '@ms/yammer-data/dist/authentication';
import { NetworkType } from '@ms/yammer-data/dist/state/types';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';

import config from '../config';

const getAuthenticator = async () => {
  const networkContext = getNetworkContext(window.location.pathname);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (config as any).adal = config.msal;
  const tenant = networkContext?.networkType === NetworkType.Canonical ? networkContext.permalink : config.msal.tenant;

  const { default: MsalPopupAuthenticator } = await import(
    /* webpackChunkName: "4-auth-msal" */ '@ms/yammer-web-authenticators/dist/embed/MsalPopupAuthenticator'
  );

  return new MsalPopupAuthenticator({ ...config.msal, tenant });
};

export type SetupAuthenticator = () => ReturnType<typeof getAuthenticator>;
export const setupAuthenticator: SetupAuthenticator = async () => {
  const authenticator = await getAuthenticator();
  setAuthenticator(authenticator);

  return authenticator;
};
